import { render, staticRenderFns } from "./ModalDocuments.vue?vue&type=template&id=5d6c9482&"
import script from "./ModalDocuments.vue?vue&type=script&lang=js&"
export * from "./ModalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports